import Vue from 'vue';
import VueRouter from 'vue-router';

import LandingHeader from '@/views/site/landing/LandingHeader';
import LandingFooter from '@/views/site/landing/LandingFooter';
import BookingHeader from '@/views/site/booking/BookingHeader';
import BookingFooter from '@/views/site/booking/BookingFooter';
import authMiddleware from './authMiddleware';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    components: {
      header: LandingHeader,
      default: () => import('@/views/site/landing/Landing.vue'),
      footer: LandingFooter
    }
  },
  {
    path: '/book',
    name: 'book',
    components: {
      header: BookingHeader,
      default: () => import('@/views/site/booking/Booking.vue'),
      footer: BookingFooter
    },
    beforeEnter(to, _, next) {
      const { store } = to.query;
      const isStoreKnown = ['finglas', 'ifsc'].includes(store);

      if (isStoreKnown) {
        window.location = `https://book.smartbooks365.com/shops/boxx-${store}`;
      }

      next();
    }
  },
  {
    path: '/booking-confirmation',
    name: 'booking-confirmation',
    components: {
      header: BookingHeader,
      default: () => import('@/views/site/booking/BookingConfirmation.vue'),
      footer: BookingFooter
    }
  },
  {
    path: '/pay-now',
    components: {
      default: () => import('@/views/site/booking/Pay.vue')
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    components: {
      header: BookingHeader,
      default: () => import('@/views/site/PrivacyPolicy.vue')
    }
  },
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    components: {
      header: BookingHeader,
      default: () => import('@/views/site/TermsAndConditions.vue')
    }
  },
  {
    path: '/admin/login',
    name: 'Admin Login',
    component: () => import('@/views/admin/auth/Login.vue')
  },
  {
    path: '/admin',
    redirect: '/admin/stores/_/bookings/calendar'
  },
  {
    path: '/admin/stores/:storeId',
    meta: {
      adminAuth: true
    },
    components: {
      header: () => import('@/views/admin/AdminHeader.vue'),
      default: () => import('@/views/admin/AdminWrapper.vue'),
      footer: () => import('@/views/admin/AdminFooter.vue')
    },
    children: [
      {
        path: '',
        redirect: 'bookings'
      },
      {
        path: 'bookings',
        name: 'bookings',
        redirect: 'bookings/calendar'
      },
      {
        path: 'bookings/calendar',
        name: 'bookings/calendar',
        component: () => import('@/views/admin/bookings/Bookings.vue')
      },
      {
        path: 'bookings/calendar/:view/:date',
        name: 'bookings/calendar/view/date',
        component: () => import('@/views/admin/bookings/Bookings.vue')
      },
      {
        path: 'bookings/add',
        name: 'bookings/add',
        component: () => import('@/views/admin/bookings/BookingAdd.vue')
      },
      {
        path: 'bookings/edit/:id',
        name: 'bookings/edit',
        component: () => import('@/views/admin/bookings/BookingEdit.vue')
      },
      {
        path: 'barbers',
        name: 'resources',
        component: () => import('@/views/admin/manage/resources/Resources.vue')
      },
      {
        path: 'barbers/add',
        name: 'resources/add',
        component: () =>
          import('@/views/admin/manage/resources/ResourceAdd.vue')
      },
      {
        path: 'barbers/edit/:id',
        name: 'resources/edit',
        component: () =>
          import('@/views/admin/manage/resources/ResourceEdit.vue')
      },
      {
        path: 'roster',
        name: 'roster',
        component: () => import('@/views/admin/manage/roster/Roster.vue')
      },
      {
        path: 'roster/:view/:date',
        name: 'rosterWithParams',
        component: () => import('@/views/admin/manage/roster/Roster.vue')
      },
      {
        path: 'packages',
        name: 'packages',
        component: () => import('@/views/admin/manage/packages/Packages.vue')
      },
      {
        path: 'packages/add',
        name: 'packages/add',
        component: () => import('@/views/admin/manage/packages/PackageAdd.vue')
      },
      {
        path: 'packages/edit/:id',
        name: 'packages/edit',
        component: () => import('@/views/admin/manage/packages/PackageEdit.vue')
      },
      {
        path: 'services',
        name: 'services',
        component: () => import('@/views/admin/manage/services/Services.vue')
      },
      {
        path: 'services/add',
        name: 'services/add',
        component: () => import('@/views/admin/manage/services/ServiceAdd.vue')
      },
      {
        path: 'services/edit/:id',
        name: 'services/edit',
        component: () => import('@/views/admin/manage/services/ServiceEdit.vue')
      },
      {
        path: 'store-settings',
        name: 'store-settings',
        component: () => import('@/views/admin/settings/shops/ShopSettings.vue')
      }
    ]
  },
  {
    path: '/admin/*',
    redirect: '/admin'
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  routes,
  base: __dirname,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(authMiddleware);

export default router;
